export default [
  {
    name: 'securityStock',
    label: 'securityStock',
    organizationProperty: true,
    type: 'number',
    default: {
      comparison: 'more',
    },
  },
]
